import { IFundingOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { FundersRorContainerComponent } from './funders-ror-container.component';
import {useWatch} from "react-hook-form";

interface StudyFundersRorContainerComponentProps {
    onFunderChange?: (study: IStudy) => void;
    handleRemoveRow?: (fundingOrganization: IFundingOrganization) => void;
    canEdit?: boolean;
}

export const StudyFundersRorContainerComponent = ({
                                                      onFunderChange,
                                                      canEdit
                                                  }: StudyFundersRorContainerComponentProps) => {
    const study = useWatch<IStudy>() as IStudy;

    const handleFundingOrgDelete = (study) => {
        handleFunderChange(study);
    };

    const handleFunderChange = (fundingOrganizations: IFundingOrganization[]) => {
        onFunderChange({ ...study, fundingOrganizations });
    };

    return (
        <div style={{ width: '100%' }}>
            {
                <FundersRorContainerComponent
                    fundingOrganizations={study.fundingOrganizations}
                    handleFunderChange={handleFunderChange}
                    canEdit={canEdit}
                    handleFundingOrgDelete={handleFundingOrgDelete}
                />
            }
        </div>
    );
};
